<template>
  <div
    class="tw-flex tw-w-full tw-max-w-full tw-cursor-pointer tw-items-center tw-text-grey-medium hover:tw-text-blackest"
  >
    <div class="tw-flex tw-items-center tw-gap-2 tw-truncate tw-text-xs">
      {{ durationFormat(durationInSeconds) }} sec
    </div>
  </div>
</template>
<script>
import ListCellDefault from '@/components/list/cell/default.vue'
import { durationFormat } from '@/helpers/i18n'

export default {
  name: 'ListCellCreativeDuration',
  extends: ListCellDefault,
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    durationInSeconds() {
      return this.timeToSeconds(this.item.duration)
    },
  },
  methods: {
    durationFormat,
    timeToSeconds(time) {
      const [h, m, s] = time.split(':')

      // s can contain fractions (e.g., "30.0600000")
      const seconds = parseFloat(s)

      return Number(h) * 3600 + Number(m) * 60 + seconds
    },
  },
}
</script>
